import createVueApp from '../../shared/vue/create-app';
import shared from '../../shared';
import initRecommendedLocationsComponent from '../../components/recommended-locations';
import {initListingCardComponent} from '../../components/card/listing-card';
import {globalActions} from '../../store/global-actions';
import initCustomControls from '../../components/custom-controls';
import initAutocompleteComponent from '../../components/map/autocomplete';
import initFavoriteSwitchComponent from '../../components/favorite-switch';
import {initCurrencyPriceComponents} from '../../components/inputs/currency-price';
import initListingContactForm from '../../components/listing-contact-form';
import initListingExtraDetailsComponent from '../../components/card/listing-extra-details';
import openPreviewMixin from '../../shared/vue/openPreviewMixin';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';
import {initGAComponents} from '../../components';
import {landingEngageMixin} from '../../components/mixins/landing-mixins';
import {advertDiscoveryTrackerMixin} from '../../components/advert-discovery-tracker-mixin';

const initLandingPage = (settings) => {
    const app = createVueApp({
        mixins: [openPreviewMixin, landingEngageMixin, advertDiscoveryTrackerMixin],
        data() {
            return {
                trackAdvertDiscoveryUrl: settings.urls.trackAdvertDiscoveryUrl,
            };
        },
        methods: {
            saveRefencedUserData(referencedUser) {
                localStorage.setItem('invitationId', referencedUser.invitationId);
                localStorage.setItem('referencedUserEmail', referencedUser.email);
            },
        },
        created() {
            this.initEngageData(settings);
            this.saveRefencedUserData(settings.referencedUser);
        },
    });

    initRecommendedLocationsComponent(app);
    initListingCardComponent(app);
    initCustomControls(app);
    initAutocompleteComponent(app);
    initFavoriteSwitchComponent(app);
    initCurrencyPriceComponents(app);
    initListingContactForm(app);
    initGAComponents(app);
    initListingExtraDetailsComponent(app);
    initCustomInputsComponents(app);

    app.mount('#app');

    return app;
};

const openRegionSelectModal = () => {
    globalActions.openRegionSelectModal();
};

export {shared, initLandingPage, openRegionSelectModal};
